/*
 * Copyright (c) 2025 SARL SIGMA POLYNESIA
 */

import { Link, LinkProps } from 'react-router-dom'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ReactElement } from 'react'
import { Menu, MenuItemProps } from '@mantine/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type CreateMenuItemProps = LinkProps & MenuItemProps & {
  icon: IconProp;
  label: string;
}

function CreateMenuItem (props: CreateMenuItemProps): ReactElement {
  const { icon, label, ...others } = props
  return (
    <Menu.Item
      leftSection={<FontAwesomeIcon fixedWidth icon={icon} />}
      component={Link}
      {...others}
    >
      {label}
    </Menu.Item>
  )
}

export default CreateMenuItem
